import React, { useState, useRef, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { toast } from "react-toastify";

import * as billPaymentActions from "store/entities/billPayment/action";

import BillPaymentProviders from 'components/__new/billPayment/BillPaymentProviders';
import { ButtonLoader, Input, SelectInput } from 'components/__new/common/form';
import FormDrawer from 'components/__new/common/form-drawer';
import useLoginInfo from 'hooks/useLoginInfo';
import useTransformedProviders from 'hooks/useTransformedProviders';
import ModalAlert from 'components/__new/common/ModalAlert';
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { electricityPurchaseValidation } from 'store/entities/billPayment/action';
import { REGEX_VALUES } from 'utils/regexValues';




const EditElectricityBeneficiary = ({ providerData, providersLoading, providers, isOpen, setIsOpen, toggleEditModal, getAllBeneficiaries, viewElectricityBeneficiary: beneficiary }) => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const billPaymentProvidersRef = useRef();
    
    const { electricityValidationLoading: isValidating, electricityValidation: validatedData, editBeneficiaryLoading, editBeneficiary } = useSelector((s) => s.entities.billPayment);    
    
    const [validatedMeter, setValidatedMeter] = useState(null);
    const [isOpenModalAlertSuccess , setIsOpenModalAlertSuccess] = useState(false)
    // const [validatedSmartCard, setValidatedSmartCard] = useState(null);
    const [isEdited, setIsEdited] = useState(false)
    const [isValidated, setIsValidated] = useState(false)
    
    const [form, setForm] = useState({
        alias: "",
        network: {},
        amount: "",
        accountType: "",
        account: "",
        name: "",
        address: "",
        phone: "",
    });
    
    const {transformedData: biller, setTransformedData: setBiller} = useTransformedProviders(providerData?.electricity, beneficiary?.product)
    

const submitForm = (e) => {
    e.preventDefault();
    
    const params = {
        meterNumber: form.account,
        service: 'electricity',
        product: form.network?.value,
        meterType: form.accountType,
        alias: form.alias,
        businessId: userInfo?.employer?._id,
    }
        
        dispatch(billPaymentActions.editBeneficiary(params, beneficiary?._id));
        setIsEdited(true)
}


const handleNameChange = (e) => {
    const { value } = e.target;
    if (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50) {
        return;
    }
    setForm({...form, alias: value})
  }

const handleAccountChange = (e) => {
    const { value } = e.target;
    if ((value.length !== 14) && (value >= 0)) {
        setForm({...form, account: value})
    }
}


useEffect(() => {
    if((form?.account?.length === 11 || form?.account?.length === 13) && form?.accountType?.length && form?.network?.value?.length) {
        const params = {
            account: form.account,
            accountType: form.accountType,
            service: form.network?.value,
            businessId: userInfo.employer._id,
        }
        setIsValidated(true)
        if(isValidated){
            dispatch(electricityPurchaseValidation(params));
            setIsValidated(false)
        }
        // dispatch(electricityPurchaseValidation(params));
    }
    // eslint-disable-next-line
}, [form?.account, form?.accountType, form?.network])


useEffect(() => {
    if(validatedData?.status === 'success') {
        setValidatedMeter(validatedData?.response);
        setForm({
            ...form,
            name: validatedData?.response?.name,
            address: validatedData?.response?.address
        })
        setIsValidated(false)
    }
    // eslint-disable-next-line
}, [validatedData])


const currentValue = useMemo(() => ({
    account: beneficiary?.meterNumber || "",
    service: 'electricity',
    product: biller,
    network: biller,
    // product: beneficiary?.network?.value,
    accountType: beneficiary?.meterType || "" ,
    alias: beneficiary?.alias || "-",
    businessId: userInfo?.employer?._id,
}), [beneficiary, biller, userInfo]);

useEffect(() => {
    if(biller){
        setForm({...currentValue});
        billPaymentProvidersRef.current?.setSelectedOption(biller)
        setBiller(null)
    }
}, [biller, currentValue, setBiller]);

useEffect(() => {
    setForm({account: beneficiary?.meterNumber, ...currentValue});
}, [beneficiary]);



// useEffect(() => {
//     setValidatedMeter(null);
// }, [isOpen])


useEffect(() => {
    if (editBeneficiary?.status === 'success' && isEdited === true){
        getAllBeneficiaries();
        setIsEdited(false);
        setIsOpen(false);
        toast.success(editBeneficiary?.message);
    }
    // eslint-disable-next-line
}, [editBeneficiary])


const disableSubmit = !form?.network?.label?.length || !(form?.account?.length === 11 || form?.account?.length === 13) || !validatedMeter
// const disableSubmit = !form?.decoderType?.label?.length || form?.account?.length !== 10 || !validatedSmartCard;

const handleCloseModal = () => {
    setIsOpen(false);
    setForm({});
    setValidatedMeter(null);
}    
    
    return (
        <>
            <ModalAlert
                successText={editBeneficiary?.message || 'Congratulations! Your beneficiaries have been saved successfully'}
                dismissText="Close"
                isOpenModalAlert={isOpenModalAlertSuccess}
                setIsOpenModalAlert={setIsOpenModalAlertSuccess}
            />
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={handleCloseModal}>
                
                <div className='w-full p-6'>
                    <FormDrawer.Title
                        close={handleCloseModal}
                        showCloseButton={true}
                        title="Edit Beneficiary"
                        description="Make changes to this beneficiary"
                    />
                
                    <form onSubmit={submitForm}>
                    <div className="w-full mt-5">
                    <Input
                            type="text"
                            label="Beneficiary Name"
                            value={form.alias}
                            // name="alias"
                            className="form-input"
                            placeholder="Enter name"
                            onChange={handleNameChange}
                        />
                            
                    
                        <div className="relative">
                            <BillPaymentProviders
                                type="electricity"
                                label="Biller"
                                tag="products"
                                providersLoading={providersLoading} 
                                providers={providers}
                                ref={billPaymentProvidersRef}
                                onValueChange={(e) => {
                                    setForm({...form, network: e, amount: "",});
                                    setValidatedMeter(null);
                                }}
                            />
                        </div>
                        
                        <div className="mt-6">
                            <SelectInput label="Meter Type" value={form.accountType} onChange={(e) => {setForm({...form, accountType: e.target.value})}}>
                                <option value="">Select</option>
                                <option value="prepaid">Prepaid</option>
                                <option value="postpaid">Postpaid</option>
                            </SelectInput>
                        </div>
                        
                        <div className='form-group relative'>
                            <label>Meter Number</label>
                            <input
                                type="number"
                                id="prl-input"
                                className="form-input"
                                value={form.account}
                                placeholder="Enter Meter Number"
                                onChange={handleAccountChange}
                            />
                            
                            <Maybe condition={validatedMeter !== null}>
                                <div className="w-full flex items-center justify-start absolute -bottom-7">
                                    <div className="flex items-center text-sm">
                                        <IconCheckCircle width={15} />
                                        <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedMeter?.name?.toLowerCase()}</div>
                                    </div>
                                </div>
                            </Maybe>
                        </div>
                        
                        <div className='my-10' />
                    </div>
                        
                        <div className="border-t w-full flex items-center justify-end mt-7 pt-5">
                            <button type="button" onClick={handleCloseModal} className="btn btn-transparent-primary mr-3">
                                Cancel
                            </button>
                            
                            <ButtonLoader type="submit" loading={editBeneficiaryLoading} disabled={disableSubmit} className="btn btn-ep-primary">
                            {isValidating ? "Validating..." : "Save Changes"}
                            </ButtonLoader>
                        </div>
                    </form>
                </div>
            
            </FormDrawer>
        </>
    )
}


export default EditElectricityBeneficiary
